import { render, staticRenderFns } from "./address-line.vue?vue&type=template&id=38d5dc35&"
import script from "./address-line.ts?vue&type=script&lang=js&"
export * from "./address-line.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports